import logger from 'src/logger';
import withProps from 'recompose/withProps';
import product from 'src/common/config/product';
import * as productTracking from '../../analytics/category/product';
import * as accountTracking from '../../analytics/category/account';

export const withSetupTracking = withProps(props => {
  try {
    productTracking.init(product.skus[props.productKey], props.analyticsContext);
    accountTracking.init(props.analyticsContext);
  } catch (error) {
    logger.error(error);
  }
});

export default withSetupTracking;
